export default __webpack_public_path__ + "static/media/zen-banner.b3a50de0.png";